module.exports = {
    // Search Component Styles
    FormStyles: {
        padding: "50px",
        margin: "50px",
        border: "3px solid black"
    },
    Button: {
        color: "black"
    }
}